import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-maker_card-click';
/**
 * Maker card on click event under the HomeHeader section.
 */
export function trackHelpCenterMakerCardClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
